export default "__VITE_ASSET__BQ7i52mN__"